// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"83a38980","171":"e8f9cd23","378":"a5e578e2","453":"3e7fefe8"}[chunkId] + ".chunk.js";
};